import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "tolls"
const TollsIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.81 2.04c-.054-.335.226-.611.565-.611.34 0 .607.279.687.608a2.58 2.58 0 0 0 1.9 1.9c.33.08.608.347.608.687 0 .339-.277.62-.612.565A3.81 3.81 0 0 1 18.81 2.04Z" />
      <path d="M15.71 1.495c-.045-.432.31-.784.745-.784.433 0 .78.353.836.783a6.049 6.049 0 0 0 5.214 5.214c.43.056.783.402.783.836 0 .434-.352.79-.784.745a7.62 7.62 0 0 1-6.794-6.794Z" />
      <path d="M12.603.865c-.036-.477.355-.865.833-.865s.862.388.904.865a9.697 9.697 0 0 0 8.794 8.793c.476.043.865.427.865.905 0 .478-.389.869-.865.833A11.43 11.43 0 0 1 12.603.865ZM2.944 7.866A1 1 0 0 1 4.31 7.5l10.2 5.889a1 1 0 0 1 .366 1.366l-2.444 4.233a1 1 0 0 1-1.367.367L.867 13.465A1 1 0 0 1 .5 12.1l2.444-4.234ZM17.448 17.863a.5.5 0 0 0-.29-.727l-1.735-.521a.5.5 0 0 0-.578.23l-.648 1.134a.5.5 0 0 0 .095.615l1.331 1.23a.5.5 0 0 0 .774-.12l1.051-1.841ZM4.96 18.389a.689.689 0 1 1 1.377 0v4.922a.689.689 0 1 1-1.377 0V18.39Z" />
    </svg>
  )
}
export default TollsIcon
